import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import { DatePicker } from 'antd';
import Button from 'antd/lib/button';
import { ConfirmModal } from '../../../common/components';
import moment from 'moment';
import { formatDate } from '../../../common/utils/helpers';
import message from 'antd/lib/message';

@translate()
export default class InstallmentShiftModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    handleModalCancel: PropTypes.func.isRequired,
    nearestRepaymentDate: PropTypes.date,
    date: PropTypes.string,
    shiftInstallments: PropTypes.func.isRequired,
  };

  state = {
    newInstallmentDate: moment().add(1, 'month')
  }



  render() {
    const { visible, handleModalCancel,  shiftInstallments ,nearestRepaymentDate, date, earlyRepayLoan, t, modalActions } = this.props;

    return (
      <Modal
        title={t('Posun dátum splátok')}
        visible={visible}
        onCancel={handleModalCancel}
        footer={null}

      >
        <div className='text-center'>
          <DatePicker
            allowClear={false}
            showToday={true}
            onChange={e => this.setState({ newInstallmentDate: e })}
            format={'DD.MM.YYYY'}
            disabledDate={(current) => {
              return moment().add(1, 'month').startOf('month')  >= current ||
                   moment().add(1,'month').date(28) <= current;
              }}
            value={this.state.newInstallmentDate}
          />
          <ConfirmModal
            onSubmit={() => { shiftInstallments(this.state.newInstallmentDate);
                }}
            message={t('Naozaj chcete posunúť splátky na tento deň mesiaca?')}
          >
          <Button style={{marginLeft: 10+'px'}} type="primary">{t('Zmeniť dátum splátky')}</Button>
          </ConfirmModal>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/InstallmentShiftModal.js